<template>
  <b-container v-if="$root.token">
    <br>
    <survey-summary :surveyRunId="$route.params.id"></survey-summary>
  </b-container>
  

</template>
<script>
// @ is an alias to /src
import SurveySummary from "@/components/SurveySummary.vue"

export default {
  name: "ScoringEvent",
  components: {
    SurveySummary
  },
  data: function() {
    return {
      
    }
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>




// WEBPACK FOOTER //
// src/views/ScoringEvent.vue